import React, { useState } from 'react';
import { List, ListItem, Box, Button, ListItemText } from '@mui/material';

const TermsAndConditions: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Splitting full text into paragraphs for more accurate control over rendering
  const paragraphs = [
    'Terms and Conditions: Details under FATCA & CRS: The Central Board of Direct Taxes has notified Rules 114F to 114H, as part of the Income-tax Rules, 1962, which require Indian Financial institutions to seek additional information which includes personal, tax and beneficial owner details and certain certifications and documentation. In relevant cases, information will have to be reported to tax authorities / appointed agencies. Should there be any change in any information provided by you, please ensure you advise us promptly, i.e., within 30 days.',
    'Certification/Decl. - I/we hereby confirm that the information provided by me/us is true, correct and complete. I hereby declare that the details furnished above are true and correct to the best of my knowledge and belief and I undertake to inform you of any changes therein, immediately. Incase any of the above information is found to be false or untrue or misleading or misrepresenting, I am aware that I may be held liable for it.',
    'I hereby consent to receiving information from Central KYC Registry through SMS/Email on the above registered number/email address. I/We hereby authorise you to kindly update/modify KRA/CKYC basis the documents submitted and also to update the account details basis any changes done on KRA/CKYC.',
    'I/We hereby provide my /our consent in accordance with Aadhaar Act, 2016 and regulations made thereunder, for (i) collecting, storing and usage (ii) validating/authenticating and (iii) updating my/our Aadhaar number(s) in accordance with the Aadhaar Act, 2016 (and regulations made thereunder) and PMLA.',
  ];

  const preview = paragraphs[0]; // Assume first paragraph as the preview

  return (
    <Box sx={{ textAlign: 'justify' }}>
      <ListItem disablePadding>
        <ListItemText primary="KRA Declaration:" primaryTypographyProps={{ fontWeight: 'bold' }} />
      </ListItem>
      <List sx={{ listStyleType: 'none', padding: 0, marginLeft: 0 }}>
        {isExpanded ? (
          paragraphs.map((paragraph, index) => (
            <ListItem key={index} disablePadding>
              <Box component="p" marginBottom={2}>
                {paragraph}
              </Box>
            </ListItem>
          ))
        ) : (
          <ListItem disablePadding>
            <Box component="p" marginBottom={2}>
              {preview}
            </Box>
          </ListItem>
        )}
        <ListItem disablePadding>
          <Box display="flex" justifyContent="flex-end" width="100%">
            {!isExpanded ? (
              <Button
                onClick={() => setIsExpanded(true)}
                sx={{ textTransform: 'none', color: 'primary.main' }}>
                Read More
              </Button>
            ) : (
              <Button
                onClick={() => setIsExpanded(false)}
                sx={{ textTransform: 'none', color: 'primary.main' }}>
                Read Less
              </Button>
            )}
          </Box>
        </ListItem>
      </List>
    </Box>
  );
};

export default TermsAndConditions;
